/* Magnum Sports stock-by-location block (snippets/product-inventory.liquid).
   16 Sep 2026: three-state rule — hides Add to cart and shows the enquiry form when out of stock at suppliers.
   One script for the product page AND the quick shop modal: Impulse builds the modal by
   fetching the product page and copying its blocks in, and copied inline scripts never run,
   so the logic lives here and re-initialises on quickview:loaded. Added 6 Sep 2026. */
(function () {
  'use strict';

  var entries = [];

  function show(el, on) { if (el) el.classList.toggle('hide', !on); }

  function render(entry, variantId) {
    var root = entry.root;
    var q = function (sel) { return root.querySelector(sel); };
    var store = q('[data-stock-store]');
    var warehouse = q('[data-stock-warehouse]');
    var order = q('[data-stock-order]');
    var out = q('[data-stock-out]');
    var notifyWrap = q('[data-stock-notify-wrap]');
    var enquireWrap = q('[data-stock-enquire-wrap]');
    var enquireForm = q('[data-stock-enquire-form]');
    var notifyForm = q('[data-stock-notify-form]');
    var toggle = q('[data-stock-notify-toggle]');
    var v = entry.stock[String(variantId)];

    if (!v) {
      show(store, false); show(warehouse, false); show(order, false); show(out, false); show(notifyWrap, false); show(enquireWrap, false);
      return;
    }
    var hasStore = v.t && v.s > 0;
    var hasWarehouse = v.t && v.w > 0;
    show(store, hasStore);
    show(warehouse, hasWarehouse);
    if (hasStore) q('[data-stock-store-qty]').textContent = v.s;
    if (hasWarehouse) q('[data-stock-warehouse-qty]').textContent = v.w;
    var nothingOnHand = !hasStore && !hasWarehouse;
    show(order, nothingOnHand && v.t && v.a && v.c);
    var isOut = nothingOnHand && !v.a;
    show(out, isOut);
    show(notifyWrap, isOut);
    show(enquireWrap, isOut);
    // Out of stock at suppliers: hide the Add to cart button altogether (the variant is on
    // inventory policy DENY, so checkout is refused regardless; this just removes the dead button).
    var section = root.closest('.product-section, .product-single__meta, [data-section-type="product"]') || document;
    section.querySelectorAll('[data-add-to-cart]').forEach(function (b) { b.classList.toggle('hide', isOut); });
    if (enquireForm) {
      var subj = enquireForm.querySelector('[data-stock-enquire-subject]');
      var prod = enquireForm.querySelector('[data-stock-enquire-product]');
      var skuEl = enquireForm.querySelector('[data-stock-enquire-sku]');
      if (prod) prod.value = prod.dataset.productBase + '?variant=' + variantId;
      if (subj && v.sku !== undefined) subj.value = subj.dataset.subjectBase + (v.sku ? ' (' + v.sku + ')' : '');
      if (skuEl && v.sku !== undefined) skuEl.value = v.sku || '';
      if (!isOut) {
        show(enquireForm, false);
        var et = q('[data-stock-enquire-toggle]');
        if (et) et.setAttribute('aria-expanded', 'false');
      }
    }
    if (!isOut && notifyForm) {
      show(notifyForm, false);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
    var tags = q('[data-stock-notify-tags]');
    var ret = q('[data-stock-notify-return]');
    if (tags) tags.value = 'bis, bis-' + variantId;
    if (ret) ret.value = ret.dataset.returnBase + '?variant=' + variantId;
  }

  function init(root) {
    if (root.dataset.stockInit) return;
    var uid = root.getAttribute('data-stock-block');
    var scope = root.parentElement || document;
    var dataEl = scope.querySelector('[data-stock-data="' + uid + '"]') ||
                 document.querySelector('[data-stock-data="' + uid + '"]');
    if (!dataEl) return;
    var stock;
    try { stock = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.stockInit = 'true';

    var entry = { root: root, stock: stock };
    entries.push(entry);

    // Product page: honour ?variant= in the URL. Modal: keep the server-rendered default variant.
    var initial = root.getAttribute('data-initial-variant');
    var inModal = !!root.closest('.product-section[data-modal="true"], .modal--quick-shop');
    var params = new URLSearchParams(window.location.search);
    if (!inModal && params.get('variant')) initial = params.get('variant');
    if (initial) render(entry, initial);

    // Back from a successful enquiry post: keep the confirmation open, hide the button.
    if (root.querySelector('[data-stock-enquire-success]')) {
      show(root.querySelector('[data-stock-enquire-wrap]'), true);
      show(root.querySelector('[data-stock-enquire-form]'), true);
      var et2 = root.querySelector('[data-stock-enquire-toggle]');
      if (et2) et2.classList.add('hide');
    }
    // Back from a successful notify-me post: keep the confirmation open, hide the button.
    if (root.querySelector('[data-stock-notify-success]')) {
      show(root.querySelector('[data-stock-notify-wrap]'), true);
      show(root.querySelector('[data-stock-notify-form]'), true);
      var t = root.querySelector('[data-stock-notify-toggle]');
      if (t) t.classList.add('hide');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-stock-block]').forEach(init);
  }

  // Notify-me and enquire toggles (delegated, so they work for blocks added to a modal later).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-stock-notify-toggle], [data-stock-enquire-toggle]') : null;
    if (!btn) return;
    var root = btn.closest('[data-stock-block]');
    var sel = btn.hasAttribute('data-stock-enquire-toggle') ? '[data-stock-enquire-form]' : '[data-stock-notify-form]';
    var form = root && root.querySelector(sel);
    if (!form) return;
    var open = form.classList.contains('hide');
    show(form, open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var f = form.querySelector('input[type="text"], input[type="email"]');
      if (f) f.focus();
    }
  });

  // Impulse fires this on document for the page and for the quick shop modal. The variant
  // object comes from Liquid's product JSON, which has no product_id, so blocks are matched
  // by variant id (unique across the store) instead.
  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    entries.forEach(function (entry) {
      if (entry.stock[String(variant.id)] && document.contains(entry.root)) {
        render(entry, variant.id);
      }
    });
  });

  document.addEventListener('quickview:loaded', initAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
